import classNames from 'classnames';
import { ReactNode, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Button from '../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import ThemeContext from '../../../contexts/themeContext';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu } from '../../../menu';
import { filterMenu } from '../../../utils/filterMenu';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);

	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();

	const rightsData = localStorage.getItem('neels_rights');
	// console.log('📌 Raw rights from localStorage:', rightsData);
	const rights = rightsData ? JSON.parse(rightsData).permissions : [];
	// console.log('✅ Parsed Rights:', rights);
	// console.log('📁 Original Menu:', dashboardPagesMenu);
	const rightRole = rightsData ? JSON.parse(rightsData) : '';
	// console.log('rightRole:', rightRole?.role);
	// Filter menu based on rights
	const allowedMenu = filterMenu(dashboardPagesMenu, rights, rightRole?.role);
	// console.log('📂 Allowed Menu (after Filter):', allowedMenu);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{/* {!doc && ( */}
				<>
					{/* <Navigation menu={dashboardPagesMenu} id='aside-dashboard' /> */}
					<Navigation menu={allowedMenu} id='aside-dashboard' />
					<NavigationLine />
					{/* <Navigation menu={categoryPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={productPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={hrmPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={qcPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={crmPagesMenu} id='aside-demo-pages' />
						<NavigationLine />
						<Navigation menu={settingPageMenu} id='aside-demo-pages' />
						<NavigationLine /> */}
					{/* <Navigation menu={demoPagesMenu} id='aside-demo-pages' />
						<NavigationLine /> */}
					{/* <Navigation menu={pageLayoutTypesPagesMenu} id='aside-menu' /> */}
				</>
				{/* // )} */}

				{/* {doc && (
					<>
						<Navigation menu={gettingStartedPagesMenu} id='aside-docMenu' />
						<NavigationLine />
						<Navigation menu={componentPagesMenu} id='aside-componentsMenu' />
						<NavigationLine />
					</>
				)} */}

				{asideStatus && doc && (
					<Card className='m-3 '>
						<CardBody className='pt-0'>
							<img srcSet={HandWebp} src={Hand} alt='Hand' width={130} height={130} />
							<p
								className={classNames('h4', {
									'text-dark': !darkModeStatus,
									'text-light': darkModeStatus,
								})}>
								{t('Everything is ready!') as ReactNode}
							</p>
							<Button
								color='info'
								isLight
								className='w-100'
								onClick={() => {
									localStorage.setItem('facit_asideDocStatus', 'false');
									setDoc(false);
								}}>
								{t('Demo Pages') as ReactNode}
							</Button>
						</CardBody>
					</Card>
				)}
			</AsideBody>
			<AsideFoot>
				{/* <nav aria-label='aside-bottom-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.setItem('facit_asideDocStatus', String(!doc));
								setDoc(!doc);
							}}
							data-tour='documentation'>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={doc ? 'ToggleOn' : 'ToggleOff'}
										color={doc ? 'success' : undefined}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{t('menu:Documentation') as ReactNode}
									</span>
								</span>
								<span className='navigation-link-extra'>
									<Icon
										icon='Circle'
										className={classNames(
											'navigation-notification',
											'text-success',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								</span>
							</span>
						</div>
					</div>
				</nav> */}
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
